define(["jquery"], function ($) {
   

    function Init() {   
        var cta = $('.cta');
        var ctaBtn = cta.find('.btn-primary');
        var ctaModalClose = cta.next('.modal').find('.close');
        //console.log(ctaModalClose);
        //form modal button click: add class return-focus. form modal close clicked, return focus to button and remove return-focus class
        ctaBtn.on("click", function() {
            if(ctaBtn.hasClass('return-focus') === false){
                ctaBtn.removeClass('return-focus');
                $(this).addClass('return-focus');
            } else {
                ctaBtn.removeClass('return-focus');
            }
        });
        ctaModalClose.on("click", function() {
            
            setTimeout(function(){
                cta.find('.return-focus').focus().removeClass('return-focus');
            },100);
        });
    }

    return {        
        Init: Init 
    };
});